import { Task } from "./task.model";
import { EmploymentPlanCorVo } from "./employment-plan-co-vo";
export class RequestVO {
  constructor(public mainObject: any, public newTask?: Task, public oldTask?: Task, public employmentPlanCorVo?: EmploymentPlanCorVo) {
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/model/RequestVO.model.ts